var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHidePassword = function SvgHidePassword(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8075f2;}.cls-2{fill:#e8e5fe;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "budicon-hide-password"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.2136,19.6655l.7214-.7217A16.9409,16.9409,0,0,1,1.071,14.5C1.8457,13.2236,6.5859,8,12.5,8a11.0612,11.0612,0,0,1,3.6975.6816l.7844-.7847A12.3441,12.3441,0,0,0,12.5,7C5.5964,7,0,13.6211,0,14.5,0,15.0322,2.0605,17.667,5.2136,19.6655Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.7964,9.3247l-.7349.7349a15.862,15.862,0,0,1,4.8823,4.44C23.1831,15.8994,18.22,21,12.5,21a11.105,11.105,0,0,1-3.7058-.6729l-.7709.7705A12.2612,12.2612,0,0,0,12.5,22C19.4036,22,25,15.4375,25,14.5,25,13.9331,22.9436,11.311,19.7964,9.3247Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.5,12a2.4237,2.4237,0,0,1,.3441.0352l.8209-.8213A3.4661,3.4661,0,0,0,9.2139,15.665l.8209-.8208A2.4615,2.4615,0,0,1,10,14.5,2.5029,2.5029,0,0,1,12.5,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.5,17a2.4235,2.4235,0,0,1-.3441-.0347l-.8209.8208a3.4661,3.4661,0,0,0,4.4512-4.4512l-.8209.8213A2.4545,2.4545,0,0,1,15,14.5,2.5029,2.5029,0,0,1,12.5,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.8535,4.1465a.5.5,0,0,0-.707,0l-20,20a.5.5,0,1,0,.707.707l20-20A.5.5,0,0,0,22.8535,4.1465Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.0609,10.06l-.6555.6555A12.4954,12.4954,0,0,1,21,13.5C20.2392,14.8994,15.2766,20,9.5562,20c-.1395,0-.2748-.0163-.4129-.0222l-.35.35A11.089,11.089,0,0,0,12.5,21c5.72,0,10.683-5.1006,11.4438-6.5A15.8529,15.8529,0,0,0,19.0609,10.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.8535,4.1465a.5.5,0,0,0-.707,0l-20,20a.5.5,0,1,0,.707.707l20-20A.5.5,0,0,0,22.8535,4.1465Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHidePassword);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hide-password.c7f2edac4b53cc8c5d343c8a3b56084c.svg";